import React from 'react';
import styles from './homebanner.module.css'

function Homebanner() {
  return (
    <div id="home" className={styles.background}>
      <h1>Feel the Farm Fresh <br/> Taste in Every Eat </h1>
      <p>Fruits & vegetables straight from<br/> farmers| organic,fresh & safe to eat| <br/> live chemical-free healthy life.</p>
      <a href="tel:+918951092635"> <button className={styles.order}>Order Now</button></a>
    </div>
    
  );
}

export default Homebanner;